import {
  Component,
  OnInit,
  Input,
  ViewChild,
  EventEmitter,
  OnDestroy,
  Output,
  AfterContentChecked
} from '@angular/core'
import { FormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs/Subject'
import { isNullOrUndefined } from 'util'
import { AuthorizeService } from 'app/service/authorize.service'

@Component({
  selector: 'app-output-case-table',
  templateUrl: './output-case-table.component.html',
  styleUrls: ['./output-case-table.component.scss']
})
export class OutputCaseTableComponent implements OnInit, OnDestroy, AfterContentChecked {
  @Output() viewCasebyId = new EventEmitter()
  @ViewChild(DataTableDirective) dtElement: DataTableDirective
  @Input() companyProfile: any
  @Input() printPage
  dtTriggerForcaseOutput: Subject<any> = new Subject()

  subscription: Subscription
  subscriptionSearch: Subscription

  form: FormGroup
  caseOutputDataTableOptions: DataTables.Settings = {}
  caseOutputDataTableOptionsPrint: DataTables.Settings = {}
  type
  initTableFirstTime = false
  listTable = []
  listHeader
  listHeaderForPrint
  symbol
  print = false
  hiddenPage = true
  constructor(
    private store: StoreService,
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private authorization: AuthorizeService
  ) { }

  ngOnInit() {
    this.listTable = []
    const { symbol } = this.activatedRoute.snapshot.params
    this.caseOutputDataTableOptions = {
      autoWidth: true,
      paging: false,
      searching: true,
      info: false,
      scrollY: '166px',
      scrollCollapse: true,
      order: [[6, 'desc']],
      language: {
        emptyTable: 'No information found'
      },
      columnDefs: [
        {
          type: 'stringMonthYear',
          targets: 6
        },
        {
          targets: 6,
          orderData: 7
        },
        {
          targets: 7,
          visible: false,
          searchable: false
        }
      ],
      destroy: true
    }
    this.caseOutputDataTableOptionsPrint = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      order: [[7, 'desc']],
      ordering: false,
      language: {
        emptyTable: 'No information found'
      },
      columnDefs: [
        {
          type: 'stringMonthYear',
          targets: 7
        },
        {
          targets: 7,
          orderData: 8
        },
        {
          targets: 8,
          visible: false,
          searchable: false
        }
      ],
      destroy: true
    }

    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.symbol = response['securitySymbol']
        this.hiddenPage = false
        this.onChangeData()
      })
    // print
    if (!isNullOrUndefined(symbol)) {
      this.symbol = symbol
      this.print = true
      this.onChangeData()
    }
  }

  onChangeData() {
    this.type = 'securitySymbol'

    if (this.initTableFirstTime) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy()
      })
    }
    this.cpmService.getCrmCase(this.symbol, this.type).then(success => {
      const listData = success
      this.listTable = []
      listData.map(obj => {
        const list = {
          symbol: obj.securitySymbol,
          comName: obj.companyNameThai,
          owner: obj.caseOwner,
          meet: obj.meetingObjective,
          caseId: obj.caseId,
          status: obj.caseStatus,
          type: obj.type,
          date: obj.lastUpdateDate,
          id: obj.id
        }
        this.listTable.push(list)
      })
      if (!this.initTableFirstTime) {
        this.dtTriggerForcaseOutput.next()
        this.initTableFirstTime = true
      } else {
        this.dtElement.dtInstance.then(() => {
          this.dtTriggerForcaseOutput.next()
        })
      }
    })
    this.listHeader = [
      'Symbol',
      // 'Company name',
      'Case owner',
      'Case ID',
      'Case type',
      'Service objective',
      'Case status',
      'Update date',
      'Hidden Update Date'
    ]
    this.listHeaderForPrint = [
      'Symbol',
      'Company name',
      'Case owner',
      'Case ID',
      'Case type',
      'Service objective',
      'Case status',
      'Update date',
      'Hidden Update Date'
    ]
  }

  ngAfterContentChecked() {
    let x = document.getElementsByClassName('dataTables_scrollBody');
    if (x[0]) {
      if (x[0].scrollHeight > x[0].clientHeight) {
        document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add("scrollHeadInner");
        document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.remove("noScrollHeadInner");
      }
      else {
        document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.add("noScrollHeadInner");
        document.getElementsByClassName('dataTables_scrollHeadInner')[0].classList.remove("scrollHeadInner");
      }
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
  passId(data) {
    this.viewCasebyId.emit(data)
  }

  rerender(): void {
    if (
      this.dtElement !== undefined &&
      this.dtElement.dtInstance !== undefined
    ) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy()
        this.dtTriggerForcaseOutput.next()
      })
    }
  }

  // get isUserHasEditPermission() {
  //   return (
  //     this.authorization.hasRole('CRM_CASE_EDIT')
  //   )
  // }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/output-case-table/output-case-table.component.ts